// Copied from ptc-common/user type to not messing up dependency
export var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType["FullName"] = "fullName";
  FieldType["Nickname"] = "nickname";
  FieldType["Title"] = "title";
  FieldType["Department"] = "department";
  FieldType["CompanyName"] = "companyName";
  FieldType["Location"] = "location";
  FieldType["Timezone"] = "timezone";
  FieldType["Email"] = "email";
  FieldType["PhoneNumber"] = "phoneNumber";
  FieldType["Avatar"] = "picture";
  FieldType["Language"] = "language";
  FieldType["LocalTime"] = "localTime";
  FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
  FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
  FieldType["RemoteTimeString"] = "remoteTimeString";
  return FieldType;
}({});
export var MUTABILITY_DETAILS_MAP = {
  fullName: 'name',
  nickname: 'nickname',
  timezone: 'zoneinfo',
  locale: 'locale',
  email: 'email',
  // extended profile
  title: 'extended_profile.job_title',
  phoneNumber: 'extended_profile.phone_number',
  companyName: 'extended_profile.organization',
  department: 'extended_profile.department',
  location: 'extended_profile.location'
};
export var CUSTOM_FIELD_PLACE = {
  email: 'email.initiateChange',
  picture: 'avatar'
};
var getFieldConfig = function getFieldConfig(data, field) {
  if ((field === 'email' || field === 'picture') && CUSTOM_FIELD_PLACE[field]) {
    return data[CUSTOM_FIELD_PLACE[field]];
  }
  var mappedFieldKey = field in MUTABILITY_DETAILS_MAP ? MUTABILITY_DETAILS_MAP[field] : undefined;
  if (!mappedFieldKey) {
    return undefined;
  }
  var profileWrite = data['profile.write'];
  return profileWrite[mappedFieldKey];
};
var convertFieldKeyToFieldType = function convertFieldKeyToFieldType(key) {
  // Check if the key can be mapped to a FieldType value
  if (Object.values(FieldType).includes(key)) {
    return key;
  }
  return undefined;
};
var getMutabilityConstraintFor = function getMutabilityConstraintFor(data, field) {
  var fieldConfig = getFieldConfig(data, field);
  if (!fieldConfig || fieldConfig.allowed) {
    return undefined;
  }
  var convertedField = convertFieldKeyToFieldType(field);
  if (!convertedField) {
    return undefined;
  }
  var reason = fieldConfig.reason;
  return {
    field: convertedField,
    reason: reason && reason.key || null
  };
};
export var transformUserManageConfig = function transformUserManageConfig(data) {
  return {
    mutabilityConstraints: Object.keys(MUTABILITY_DETAILS_MAP).map(function (field) {
      return getMutabilityConstraintFor(data, field);
    }).filter(function (constraint) {
      return constraint !== undefined;
    })
  };
};